"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _utils.unstable_generateUtilityClass;
    }
});
var _utils = require("@mui/utils");
